module.exports = new __parcel__URL__("jpd-prioritization-delivery-status.90946ca3.svg").toString();